import React from "react";
import { motion } from "framer-motion";

export default function Artboard({children}) {
  return (
    <motion.div
      initial={{ opacity: 0 , y:40}}
      animate={{ opacity: 1 , y:0}}
      transition={{ duration: 0.5 , delay: 0.1}}
      className={`bg-[#ffffff08] backdrop-blur-sm rounded-lg max-w-screen p-5 h-fit
       flex flex-col items-center justify-between`}>
        {children}
    </motion.div>
  );
}
